import { useEffect } from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

import { AppHeader } from '../../../app/components/app-header';
import { uiStore } from '../../../core/stores/ui-store';
import { UserSettingsPageLayout } from '../../../routes/settings/components/user-settings-page.layout';

const menu = [
  {
    key: 'profile',
    label: 'Profile',
    href: `./profile`,
  },
  {
    key: 'security',
    label: 'Password and authentication',
    href: `./security`,
  },
  {
    key: 'notifications',
    label: 'Notifications',
    href: `./notifications`,
  },
  {
    key: 'workspaces',
    label: 'Workspaces',
    href: `./workspaces`,
  },
];

export const UserSettingsPage = () => {
  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Personal settings',
    };

    uiStore.showBack = true;
  }, []);

  return (
    <Main>
      <div className="mobile-only">
        <AppHeader />
      </div>

      <UserSettingsPageLayout title="Personal Settings" menu={menu}>
        <Outlet />
      </UserSettingsPageLayout>
    </Main>
  );
};

const Main = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
